export const FIRM_DOCUMENT_FOLDER_ACTIONS_TEST_IDS = {
  addSubfolderAction: (folderId: number) => `firm-documents-folder-add-subfolder-action-${folderId}`,
  deleteAction: (folderId: number) => `firm-documents-folder-delete-action-${folderId}`,
  renameAction: (folderId: number) => `firm-documents-folder-rename-action-${folderId}`,
  root: (folderId: number) => `firm-documents-folder-actions-${folderId}`,
  trigger: (folderId: number) => `firm-documents-folder-actions-trigger-${folderId}`,
  uploadDocumentAction: (folderId: number) => `firm-documents-folder-upload-document-action-${folderId}`,
} as const;
